import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, inject } from '@angular/core';
import { AccessState } from '@core/frontend-shared';
import { FeatureMenuItemService } from '@core/frontend-shared/feature';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LayoutFrontpageComponent } from '@mpf/ui/frontend-shared/layout-frontpage';
import { FeedbackButtonComponent } from '@common/feedback/frontend';
import { AsyncPipe } from '@angular/common';
import { UiGridComponent } from '@common/ui/frontend-shared/grid';
import { UiButtonComponent, UiHoverLabelButtonComponent } from '@common/ui/frontend-shared/button';
import { RouterLink } from '@angular/router';
import { CoursesContinueLastCourseComponent } from '@mpf/courses/frontend-shared';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { RouterLinkResolverPipe } from '@core/frontend-shared';

@Component({
    selector: 'mpf-landingpage',
    templateUrl: './landingpage.component.html',
    styleUrls: ['./landingpage.component.scss'],
    animations: [
        trigger('OutAnimation', [
            transition(':leave', [
                style({ opacity: 1 }),
                animate('.9s ease-in', style({ opacity: 0 }))
            ])
        ]),
    ],
    styles: [],
    imports: [LayoutFrontpageComponent, FeedbackButtonComponent, UiGridComponent, UiButtonComponent, UiHoverLabelButtonComponent, RouterLink, CoursesContinueLastCourseComponent, UiIconComponent, AsyncPipe, RouterLinkResolverPipe]
})
export class LandingpageComponent implements AfterViewInit {
	loggedIn$ = inject(Store).select(AccessState.loggedIn) 
	userData$ = inject(Store).select(AccessState.accessData('user')) 
	isManager$ = inject(Store).select(AccessState.accessData('isManager')) 

	hasManagerMenuItems$:Observable<boolean>;
	
	// @ViewChild('video',{static:false}) video:ElementRef;
	muteState = true;
	// videoVisible = true;

	constructor(
		featureMenuItemService:FeatureMenuItemService,
	) {
		this.hasManagerMenuItems$ = featureMenuItemService.hasAccessibleMenuItems('managementToolbar')
	}


	ngAfterViewInit() {
		// this.video.nativeElement.addEventListener('timeupdate', this.videoListener);
	}

	// videoListener = (event) => {
	// 	const progress = this.video.nativeElement.currentTime / this.video.nativeElement.duration;
	// 	if(progress>.95) {
	// 		this.video.nativeElement.removeEventListener('timeupdate', this.videoListener);
	// 		this.videoVisible = false;
	// 	}
	// }

	// toggleVideoMuteState() {
	// 	const video = this.video.nativeElement;
	// 	this.muteState = video.muted = !video.muted;
	// }

}
